import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataDisplayerModule } from './data-displayer/data-displayer.module';
import { FileUploadModule } from './file-upload/file-upload.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NavbarModule } from './navbar/navbar.module';
import { EntityManagerModule } from './entity-manager/entity-manager.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { ModeProviderModule } from './mode-provider/mode-provider.module';
import { SidebarModule } from './sidebar/sidebar.module';
import { ProgressSpinnerModule } from './progress-spinner/progress-spinner.module';
import { ProgressSpinnerDemoComponent } from './progress-spinner-demo/progress-spinner-demo.component';
import { MatDialogModule } from '@angular/material/dialog';

const DECLARATIONS = [ProgressSpinnerDemoComponent];
const IMPORTS = [
  SidebarModule,
  DataDisplayerModule,
  FileUploadModule,
  NavbarModule,
  EntityManagerModule,
  ModeProviderModule,
  RouterModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MatButtonModule,
  MatDialogModule,
  MatSidenavModule,
  MatIconModule,
  MatMenuModule,
  ProgressSpinnerModule,
];

@NgModule({
  declarations: DECLARATIONS,
  imports: IMPORTS,
  exports: [...DECLARATIONS, ...IMPORTS],
})
export class ComponentModule {}
